@import 'styles/mixins';
@import 'styles/variables';

.largerLeftContent {
  display: flex;
  flex-direction: column;
  height: 400px;
  justify-content: space-between;
  max-width: 448px;
}

.subTitle {
  margin: 0 auto 52px;
  max-width: 400px;

  @include for-tablet-portrait-max {
    margin-bottom: 88px;
  }
}

.helpText {
  @include md-regular;

  color: var(--neutral-30);

  .contactUsLink {
    color: var(--action-60);
  }
}
